import React, { Component } from 'react'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify';
import loadable from '@loadable/component';
import { cookieHelpers } from 'shared-helpers';

import * as userActions from '../redux/actions/userActions';
import routes from '../routes';
import AmplitudeHelperClass from '../lib/amplitudeHelper';

import MsgNotAudio from '/src/audio/msg-notification.mp3';

import MagnittHeader from '../MicroFrontends/MagnittHeader';
import MagnittFooter from '../MicroFrontends/MagnittFooter';
import SideNav from '../MicroFrontends/SideNav';
import NoMatch from '../MicroFrontends/NoMatch';

const ErrorBoundary = loadable(() => import(/* webpackChunkName: "ErrorBoundary" */ './ErrorBoundary'));

const amplitudeHelper = new AmplitudeHelperClass();

class App extends Component {

    constructor(props) {
        super(props);
        const { userReducer } = this.props.reduxStore;

        this.state = {
            id: '',
            //showRequestDemo: false,
            email: '',
            emailPlaceholder: '',
            emailError: false,
            shrink: false,
            showSubscribe: false,
            height: '',
            isPlayNotSound: false,
            roles: userReducer.roles,
            userState: userReducer
        }
    }

    componentDidMount() {
        const { userState } = this.state;

        window.addEventListener("load", this.handleOnLoad)
        !this.props.reduxStore.userReducer.is_loggedin ? this.setState({ showSubscribe: true }) : this.setState({ showSubscribe: false })

        setTimeout(function () { //Start the timer
            const user = this.props.reduxStore.userReducer;

            amplitudeHelper.identifyUser(user);

        }.bind(this), 3000);

        this.watchUserCookieChanges();

        // When another tab logs in (localStorage.loggedIn = true), hard-refresh this tab
        // so main and header both re-initialize from the latest cookie/session.
        window.addEventListener('storage', this.handleStorageLoginSync);

        if (userState?.is_loggedin) {
            const contentBoxes = document.getElementsByClassName('content-box');
            if (contentBoxes) {
                Array.from(contentBoxes).forEach(element => {
                    if (!element.classList.contains('content-box-logged-in')) {
                        element.classList.add('content-box-logged-in');
                    }
                });
            }
        } else {
            const contentBoxes = document.getElementsByClassName('content-box');
            if (contentBoxes) {
                Array.from(contentBoxes).forEach(element => {
                    if (element.classList.contains('content-box-logged-in')) {
                        element.classList.remove('content-box-logged-in');
                    }
                });
            }
        }
    }

    /**
     * watch for user cookie changes from shared
     * then compare to react/content cookie & if there's a mismatch, update view
     */
    watchUserCookieChanges = () => {
        const { userState } = this.state;
        // Create a wrapper that prevents syncing empty state from shared when main has valid data
        const safeContext = {
            setState: (newState) => {
                const sharedUserState = newState.userState;
                const mainUserState = this.state.userState;

                // Main is the source of truth when it has valid logged-in data
                // Never sync empty/logged-out state from shared if main is logged in
                if (mainUserState && mainUserState.is_loggedin && mainUserState.token && mainUserState.user_id) {
                    // If shared is logged out/empty but main is logged in, ALWAYS ignore it
                    if (!sharedUserState || !sharedUserState.is_loggedin || !sharedUserState.token || !sharedUserState.user_id) {
                        return; // Don't sync empty/logged-out state
                    }

                    // If both are logged in but user IDs don't match, keep main's (it's the source of truth)
                    if (sharedUserState.user_id !== mainUserState.user_id) {
                        return;
                    }

                    // If tokens don't match but user IDs match, prefer main's token (it's more recent from login)
                    if (sharedUserState.token !== mainUserState.token) {
                        return; // Don't sync stale token from shared
                    }

                    // If everything matches, no need to sync
                    return;
                }

                // Only sync if main is logged out and shared is logged in (shared logs in first)
                // Or if both are logged out (sync logout state)
                this.setState(newState);
            }
        };
        cookieHelpers.watchCookieChanges(userState, safeContext);
    }

    handleStorageLoginSync = (event) => {
        if (event.storageArea !== window.localStorage) return;
        if (event.key !== 'loggedIn') return;

        try {
            const loggedIn = JSON.parse(event.newValue);
            if (loggedIn) {
                // A different tab just logged in. Reload this tab so main + shared
                // both bootstrap from the new cookie/session consistently.
                window.location.reload();
            }
        } catch (error) {
            console.error(error)
        }
    }

    componentWillUnmount() {
        let eventName = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) ? 'pagehide' : 'beforeunload'
        // window.addEventListener(eventName, this.handleBeforeUnload)
        window.removeEventListener("load", this.handleOnLoad)
        //window.addEventListener("scroll", this.handleScroll)
        window.removeEventListener('storage', this.handleStorageLoginSync);
    }

    componentDidUpdate(prevProps) {

        // Sync userState from Redux when it changes (e.g., after login)
        // Only sync if the actual user data changed, not just reference equality
        const prevUser = prevProps.reduxStore.userReducer;
        const currentUser = this.props.reduxStore.userReducer;
        const userChanged = prevUser.is_loggedin !== currentUser.is_loggedin ||
            prevUser.user_id !== currentUser.user_id ||
            prevUser.token !== currentUser.token;

        if (userChanged) {
            this.setState({ userState: currentUser });
        }


    }

    /**
     * This method will play sound whenever there is a new message
     */
    handleNewMsgSound = () => {
        const isNewMsgSound = this.props.isNewMsgSound;
        if (isNewMsgSound) {
            return <audio ref="audioRef" src={MsgNotAudio} controls autoPlay />;
        }

        return null;
    }

    render() {

        const { userState } = this.state;
        const { history } = this.props;

        return (
            <div>

                <ToastContainer newestOnTop={true} />

                <SideNav userState={userState} />

                <div className={`main-content  ${userState?.is_loggedin ? 'main-content-logged-in' : ''}`} id="panel">

                    <MagnittHeader history={history} userState={userState} />

                    <div id='content' className='content-container'>

                        <ErrorBoundary>

                            <Switch>
                                {routes.map((route) => {
                                    const { path, exact, component, ...props } = route;
                                    let Component = route.component;
                                    let locationSearch = {};

                                    // Handle client-side component redirects
                                    if (route.getRedirectComponent) {
                                        const redirectResult = route.getRedirectComponent(userState);
                                        if (redirectResult && redirectResult.redirectComponent) {
                                            Component = redirectResult.redirectComponent;
                                            locationSearch = {
                                                search: `&redirected=true&from=${encodeURIComponent(redirectResult.path)}
											&reason=${encodeURIComponent(redirectResult.reason || 'redirect')}
											&pageName=${encodeURIComponent(redirectResult.pageName || '')}`
                                            };
                                        }
                                    }

                                    return (
                                        <Route
                                            key={path}
                                            path={path}
                                            exact={exact}
                                            render={routeProps => (
                                                <Component {...routeProps} {...props} locationSearch={locationSearch} userState={userState} />
                                            )}
                                        />
                                    );
                                })}

                                {/* 301 redirects */}
                                <Redirect exact from={`/enablers`} to={{ pathname: `/investors`, state: { status: 301 } }} />
                                <Redirect exact from={`/corporates`} to={{ pathname: `/investors`, state: { status: 301 } }} />
                                <Redirect exact from={`/subscribe-magnitt-plus`} to={{ pathname: `/pricing`, state: { status: 301 } }} />
                                <Redirect exact from={`/savedsearch`} to={{ pathname: `/dashboards`, state: { status: 301 } }} />
                                <Redirect exact from={`/difc-startups`} to={{ pathname: `/client-directory`, state: { status: 301 } }} />
                                <Redirect exact from={`/exits`} to={{ pathname: `/startups`, state: { status: 301 } }} />
                                <Redirect exact from={`/contact-sales`} to={{ pathname: `/pricing`, state: { status: 301 } }} />
                                <Redirect exact from={`/mysettings/cards`} to={{ pathname: `/mysettings`, state: { status: 301 } }} />
                                <Redirect exact from={`/mysettings/payment-history`} to={{ pathname: `/mysettings`, state: { status: 301 } }} />

                                {/* fix for double slashes user typo */}
                                <Redirect from="*//*" to="*/*" />

                                <Route render={(props) => <NoMatch {...props} />} />

                            </Switch>

                            {this.handleNewMsgSound()}

                        </ErrorBoundary>

                        <MagnittFooter />
                    </div>

                </div>

            </div>
        )
    }

}


const mapStateToProps = (state) => ({
    reduxStore: state
})
const mapDispatchToProps = dispatch => ({
    userActions: bindActionCreators(userActions, dispatch),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))

